// ================= BASE CARD =================
export const cardStyle = {
  background: "#ffffff",
  borderRadius: "16px",
  padding: "18px",
  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
  border: "1px solid rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

// ================= GRID =================
export const dashboardGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
  gap: "20px",
  marginTop: "24px"
};

// ================= TEXT =================
export const titleStyle = {
  fontSize: "15px",
  fontWeight: "600",
  color: "#1E293B",
  display: "flex",
  alignItems: "center",
  gap: "8px"
};

export const labelStyle = {
  fontSize: "12px",
  color: "#64748B"
};

export const bigNumber = {
  fontSize: "26px",
  fontWeight: "700",
  color: "#0F172A"
};

export const subText = {
  fontSize: "12px",
  color: "#6B7280"
};

export const cardTitle = {
  fontSize: "15px",
  fontWeight: 600,
  color: "#0F172A",
  marginBottom: "4px"
};

export const cardSubtext = {
  fontSize: "12px",
  color: "#64748B",
  marginBottom: "12px"
};

export const cardNumber = {
  fontSize: "28px",
  fontWeight: 700,
  color: "#0F172A",
  lineHeight: 1.2
};

// ================= BUTTONS =================
export const buttonPrimary = {
  background: "#2563eb",
  color: "#ffffff",
  padding: "8px 14px",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "500"
};

export const buttonSecondary = {
  background: "#e5e7eb",
  color: "#111827",
  padding: "8px 14px",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
};

// ================= STAT BOX =================
export const statBox = {
  flex: 1,
  background: "#F1F5F9",
  padding: "12px",
  borderRadius: "12px",
  textAlign: "center"
};

// ================= PROGRESS =================
export const progressBar = {
  height: "10px",
  background: "#E2E8F0",
  borderRadius: "10px",
  marginTop: "12px",
  overflow: "hidden"
};

export const progressFill = {
  height: "100%",
  background: "linear-gradient(90deg, #0F766E, #14B8A6)",
  borderRadius: "10px",
  transition: "width 0.4s ease"
};